import React from 'react'

export default class IssuesSettings extends React.Component {
  render () {
    return (<div>
      <h2>Settings</h2>
      <p>Coming soon</p>
    </div>)
  }
}



// WEBPACK FOOTER //
// ./src/pages/issues/settings/index.js